import * as Yup from "yup";
import { useFormik } from "formik";
import { sha256 } from "js-sha256";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, Fragment } from "react";

import pages from "../../../constants/pages";
import {
  TextField,
  LoadingButton,
  OTPInput,
  Loader,
  CaptchaDisplay,
  SelectField,
  Autocomplete,
} from "../../../components";
import { useAlert, useAxiosV2, useAxios } from "../../../hooks";
import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { MdDocumentScanner } from "react-icons/md";
import AadharCardBack from ".././assests/AadharCard.svg";
import EditButton from ".././assests/edit.svg";
import VerificationPopup from "../../user step components/VerificationPopup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { getVisitorFaceData } from "../../../utils/getVisitorFaceData";
import { styled } from "@mui/material/styles";
import { HourglassEmpty } from "@mui/icons-material";

const OuterBox3 = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  background: "#ffffff",

  [theme.breakpoints.up("sm")]: {
    width: "100%", // full width for small devices
  },
  [theme.breakpoints.up("md")]: {
    width: "700px", // tablets
  },
  [theme.breakpoints.up("lg")]: {
    width: "900px", // laptops
  },
  [theme.breakpoints.up("xl")]: {
    width: "1100px", // large desktops
  },
}));

const MyComponent = ({
  OuterBox2,
  OuterPaper,
  documentsList,
  errorUrl,
  handleIdentityTypeChange,
  selectDocuments,
  setSelectDocuments,
  handleDigiLockerVerification,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const queryParams = new URLSearchParams(location.search);

  const digiLockerID = queryParams.get("id");

  const handleGoBack = () => {
    // setIdentityType("");
    // setVerification(false);
    digiLockerID ? navigate(errorUrl) : navigate(-1);
  };

  // Helper to darken light colors
  const adjustColor = (hex) => {
    if (!hex) return "#c4c412";

    // Remove '#' if present
    hex = hex.replace("#", "");

    // Convert shorthand hex (like #fc0)
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((x) => x + x)
        .join("");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Check brightness
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;

    // If too bright, darken it
    if (brightness > 180) {
      const darken = (val) => Math.max(0, val - 60);
      return `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})`;
    }

    return `#${hex}`;
  };

  return (
    <Fragment>
      <Grid item container>
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox2>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <div
                  style={{
                    // width: "95vw",
                    position: "relative",
                    height: "35vh",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      position: "relative",
                      zIndex: "999999",
                      top: "47%",
                      left: "2%",
                      width: "96.25%",
                    }}
                  >
                    <Typography
                      variant="h3"
                      fontWeight={900}
                      sx={{ marginTop: "7.5px" }}
                    >
                      {"Verify Profile Using DigiLocker"}
                    </Typography>

                    <Typography
                      variant="body1"
                      fontWeight={500}
                      sx={{ marginTop: "7.5px", color: "#00000099" }}
                    >
                      {`Please use DigiLocker details to verify your profile.`}
                    </Typography>

                    <TextField
                      select
                      size="small"
                      style={{ marginTop: "10px", background: "white" }}
                      value={selectDocuments}
                      onChange={(e) => {
                        setSelectDocuments(e.target.value);
                        handleIdentityTypeChange(e.target.value);
                      }}
                    >
                      {documentsList?.map((item, index) => (
                        <MenuItem key={item.id} value={item._id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    {documentsList?.filter((item) => item?.document_id == 1)[0]
                      ?.display && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.2,
                          mt: 2,
                          backgroundColor: documentsList?.filter(
                            (item) => item?.document_id == 1
                          )[0]?.color,
                          color: "#060606ff", // dark gold text
                          padding: "8px 14px",
                          borderRadius: "4px",
                          borderLeft: `4px solid ${adjustColor(
                            documentsList.filter(
                              (item) => item?.document_id == 1
                            )[0]?.color
                          )}`, // light yellow left bar
                          // width: "",
                          boxShadow: `0 0 0 1px ${
                            documentsList.filter(
                              (item) => item?.document_id == 1
                            )[0]?.color
                          } inset`, // subtle border like in screenshot
                        }}
                      >
                        <HourglassEmpty sx={{ fontSize: 18 }} />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          {
                            documentsList.filter(
                              (item) => item?.document_id == 1
                            )[0]?.message_note
                          }
                        </Typography>
                      </Box>
                    )}
                  </Grid>

                  <img
                    style={{
                      height: "35vh",
                      position: "absolute",
                      top: "0px",
                    }}
                    src={AadharCardBack}
                  />
                </div>
              </OuterPaper>
            </OuterBox2>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        container
        mt={
          documentsList?.filter((item) => item?.document_id == 1)[0]?.display
            ? 7.5
            : 0
        }
      >
        <Grid item container justifyContent={"center"}>
          <Grid
            item
            container
            md={12}
            sl={6}
            sx={{
              justifyContent: "start",
              alignContent: "start",
            }}
          >
            <OuterBox3>
              <OuterPaper style={{ padding: "0px" }} elevation={3}>
                <Grid item padding={"2%"} textAlign="center">
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      marginBottom: "25px",
                    }}
                  >
                    {/* Verify Your Identity */}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      marginBottom: "40px",
                      color: "text.secondary",
                    }}
                  >
                    Click the button below to start verification with
                    DigiLocker.
                    <br /> <br /> Please select your Aadhaar for verification.
                    Other DigiLocker documents are not supported.
                  </Typography>

                  <LoadingButton
                    loading={loading}
                    onClick={() => {
                      setLoading(true);
                      handleDigiLockerVerification(3);
                      // setLoading(false);
                    }}
                    variant="contained"
                    sx={{
                      backgroundColor: "#3936EF",
                      color: "#fff",
                      fontWeight: 600,
                      padding: "10px 30px",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontSize: "16px",
                      "&:hover": {
                        backgroundColor: "#2e2bd6",
                      },
                    }}
                    style={{ marginBottom: "10px" }}
                  >
                    Start Verification
                  </LoadingButton>

                  <Grid
                    container
                    justifyContent="center"
                    sx={{ marginTop: "20px" }}
                  >
                    <LoadingButton
                      onClick={handleGoBack}
                      backgroundColor="#F5F0E5"
                      sx={{
                        color: "black",
                        backgroundColor: "#F5F0E5",
                        textTransform: "none",
                        padding: "8px 24px",
                        fontWeight: 500,
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "#ebe6db",
                        },
                      }}
                    >
                      Back
                    </LoadingButton>
                  </Grid>
                </Grid>
              </OuterPaper>
            </OuterBox3>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default MyComponent;
